import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MenuItem, MenuItemCreate, MenuItemFilter } from '../data/menuItem';

export function createMenuItemService(client: AxiosInstance) {
  return createCrudService<MenuItem, MenuItemCreate, MenuItemFilter>(
    client,
    '/restaurant/MenuItem',
    'menuItemId',
  );
}

export type MenuItemService = CrudService<MenuItem, MenuItemCreate, MenuItemFilter>;
